import { render } from "./UserRoleManagement.vue?vue&type=template&id=5845bffa&scoped=true&ts=true"
import script from "./UserRoleManagement.vue?vue&type=script&lang=ts"
export * from "./UserRoleManagement.vue?vue&type=script&lang=ts"

import "./UserRoleManagement.vue?vue&type=style&index=0&id=5845bffa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5845bffa"]])

export default __exports__